{{ batch?.name + ' (' + batch.id + ')' }}

<div *ngIf="hasSettings">
    <span
        class="fa fa-cog settings"
        (click)="onSettingsClick($event)"
    ></span>
</div>

<app-context-menu
    [contextMenuItems]="contextMenuItems"
></app-context-menu>
